// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c0867807","453":"4670b3e9","732":"baef60e9"}[chunkId] + ".chunk.js";
};